import * as React from "react";
import { Card, CardHeader, Caption1, Button, makeStyles, tokens, Text } from "@fluentui/react-components";
import { StoreMicrosoftRegular, MoreHorizontal20Regular } from "@fluentui/react-icons";
import { PublicProduct } from "../../dto/PublicProduct";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles({
    headerImage: {
        borderRadius: "4px",
        maxWidth: "44px",
        maxHeight: "44px",
    },
    caption: {
        color: tokens.colorNeutralForeground3,
    },
    text: {
        margin: "0"
    },
    card: {
        width: "100%",
        maxWidth: "100%",
        height: "fit-content",
        cursor: "pointer"
    }
});

export interface ProductCardProps
{
    product: PublicProduct;
}

export const ProductCard: React.FC<ProductCardProps> = ({product}) =>
{
    const styles = useStyles();
    const navigate = useNavigate();

    const handleOnClick = React.useCallback(() =>
    {
        navigate(`products/${product.guid}`);
    }, [navigate, product]);

    return (
        <Card className={styles.card} onClick={handleOnClick}>
            <CardHeader
                image={
                    <StoreMicrosoftRegular fontSize={48} />
                }
                header={
                    <Text weight="semibold">{product.name}</Text>
                }
                description={
                    <Caption1 className={styles.caption}>Trial available</Caption1>
                }
                action={
                    <Button
                        appearance="transparent"
                        icon={<MoreHorizontal20Regular />}
                        aria-label="More options"
                    />
                }
            />

            <p className={styles.text}>
                {product.shortDescription}
            </p>
        </Card>
    )
};